import {useState, useEffect} from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useTokenContext } from "App";

// Billing page components
import ShopsList from "layouts/retailerShops/components/ShopsList";
import ModalDialog from "components/ModalDialog/ModalDialog";
import ModalShopData from "./components/Data/ModalShopData";

import {getMyShops} from "api/shops/getShops"

function RetailerShops() {
  const [shops, setShops] = useState(null);
  const {token} = useTokenContext();
  const [modalShop, setModalShop] = useState(null);
  const [showModal, setShowModal] = useState(false)
  
  const modalData = <ModalShopData shop={modalShop}/>
  
  const doGetShops = async () => {
    try{
      let shopsPromise = await getMyShops(token);
      setShops(shopsPromise);

    } catch (error) {
      console.error("Error on get shops: ", error)
    }
  }

  useEffect(() => {
    doGetShops();
  }, []);

  function onEditClick(shop){
    setModalShop(shop);
    setShowModal(true);
  }

  function onCloseModalClick(){
    setShowModal(false);
  }

  return (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={1}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              {shops && 
              <ShopsList shops={shops["data"]} onEditClick={onEditClick}/>
              }
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {showModal &&
      <ModalDialog 
        content={modalData}
        onCloseModalClick={onCloseModalClick}
        rightButton={"Save"}
        onRightButtonClick={onCloseModalClick}
        title="Edit Shop" 
      />
    }
    </>
  );
}

export default RetailerShops;
